import { createContext } from 'react';
import MetricsContextPropsType from './ContextPropTypes';
import config from './config';

export default createContext<MetricsContextPropsType>(config);
